import { ProductV2, STORE_SPECIAL } from '@common'

export const isStoreSpecial = (product: ProductV2) => {
  return product.type === 'offer' && product.tags?.includes(STORE_SPECIAL)
}

export const isSeasonPass = (product: ProductV2) => {
  return !!product.contentCounts.SEASON_PASS
}

export const isNormalOffer = (product: ProductV2) => {
  return product.type === 'offer' && !isSeasonPass(product) && !isStoreSpecial(product)
}

// sort by priority if available, else by price with highest first
export const sortByPriority = (a: ProductV2, b: ProductV2) => {
  if (a.priority !== b.priority) {
    return b.priority - a.priority
  }

  const priceA = Object.values(a.prices)[0]
  const priceB = Object.values(b.prices)[0]
  return priceB - priceA
}

export function isSquadGoldPack(product: ProductV2) {
  return product.game === 'squadbusters' && product.id.includes('com.supercell.squad.scid.goldpack')
}
